(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function OEProductHero(elem) {
        Behaviors.init(OEProductHero, this, arguments);

        var $thisElem = this.$elem,
            slider = $thisElem.find('.OEProductHero-gallery--slider'),
            sliderNav = $thisElem.find('.OEProductHero-gallery--slider-nav');

        slider.slick({
            slidesToShow: 1,
            fade: true,
            arrows: false,
            asNavFor: sliderNav,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: true
                    }
                }
            ]
        });

        sliderNav.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12H5m0 0 7-7m-7 7 7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            nextArrow: '<span class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14m0 0-7-7m7 7-7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            focusOnSelect: true,
            asNavFor: slider,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });

    }

    Behaviors.inherit(OEProductHero, Behaviors.Behavior);

    OEProductHero.QUERY = "[data-oeproduct-hero]";

    Behaviors.register_behavior(OEProductHero);

    module.OEProductHero = OEProductHero;

    return module;

}(window.jQuery, window.Behaviors));